import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import { useLocaleStore } from '@/stores/locale'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const localeStore = useLocaleStore()

const antdTheme = computed(() => ({
  token: {
    colorPrimary: '#722ed1',
    borderRadius: 4,
    fontSize: 14,
  },
}))

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: _unref(localeStore).antdLocale,
    theme: antdTheme.value
  }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }, 8, ["locale", "theme"]))
}
}

})